import './HomeList.page.css'
import type { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import LoaderAtom from 'components/atoms/Loader.atom'
import { useHomeList } from './HomeList.hook'
import { ErrorType } from './HomeList.types'
import { ScannerMolecule } from './ScanQR/ScanQR.page'
import { UserAndPassPage } from './UserAndPass/UserAndPass.page'

function errorHandler(t: TFunction<string, undefined>) {
  return function (e: string, translate = true) {
    if (!translate) {
      return toast.error(e)
    }

    if (e.includes(ErrorType.userNotFound)) {
      return toast.error(t('home.user-not-found'))
    } else if (e.includes(ErrorType.userLogin)) {
      return toast.error(t('home.user-login'))
    } else if (e.includes(ErrorType.badRequest)) {
      return toast.error(t('home.invalid-qr'))
    } else if (e === ErrorType.invalidCredentials) {
      return toast.error(t('home.invalid-password'))
    } else {
      console.error('[Error handler]: ', e)
      return toast.error(t('home.unknown-error'))
    }
  }
}

export const HomeListPage = () => {
  const { t } = useTranslation('global')
  const { loading, loginByUserPass, loginWithKeycloak, loginWithQR } =
    useHomeList(errorHandler(t))

  return (
    <div className="flex flex-col flex-grow gap-4 overflow-auto py-10 px-4">
      {loading && <LoaderAtom>{t('loader.message') + '.'}</LoaderAtom>}

      <div className="flex flex-col justify-between h-full gap-2">
        <UserAndPassPage
          onLogin={loginByUserPass}
          onLoginKeycloack={loginWithKeycloak}
        />
        <ScannerMolecule onScan={loginWithQR} />
      </div>
    </div>
  )
}
